// Mock data per Studio Tecnico Geometra Gabriele Pastore

export const studioInfo = {
  name: "Gabriele Pastore",
  title: "Geometra - Topografo",
  tagline: "Precisione Tecnica, Innovazione Digitale",
  description: "Studio tecnico specializzato in rilievi topografici avanzati, aerofotogrammetria con droni, modellazione BIM e coordinamento sicurezza cantieri.",
  email: "geom.gabrielepastore@gmail.com",
  emailPec: "gabriele.pastore@geopec.it",
  phone: "+39 3793965329",
  address: "Via Ciciniello n.23, 85100 Potenza, Italia",
  piva: "02151450760",
  timbro: "3306"
};

export const services = [
  {
    id: 1,
    number: "01",
    title: "Rilievi Topografici",
    description: "Rilievi topografici di precisione con strumentazione GPS e stazione totale per cantieri, strade, terreni agricoli e aree boschive.",
    icon: "Compass",
    details: [
      "Rilievi plano-altimetrici",
      "Tracciamenti e picchettamenti",
      "Riconfinamenti catastali",
      "Verifiche di quote e livellazioni"
    ]
  },
  {
    id: 2,
    number: "02",
    title: "Aerofotogrammetria con Droni",
    description: "Rilievi aerofotogrammetrici georeferenziati con droni DJI Mavic 3 Enterprise RTK.",
    icon: "Plane",
    details: [
      "Ortofoto ad alta risoluzione",
      "Modelli digitali del terreno (DTM/DSM)",
      "Rilievi LIDAR e termografici",
      "Mappature aeree georeferenziate"
    ]
  },
  {
    id: 3,
    number: "03",
    title: "Modellazione BIM e Restituzione 3D",
    description: "Modellazione Building Information Modeling (BIM) e restituzione digitale di edifici e infrastrutture con visualizzazione in Virtual Reality.",
    icon: "Box",
    details: [
      "Modelli BIM con Revit e Archicad",
      "Restituzione da nuvola di punti",
      "Render fotorealistici",
      "Virtual Reality con Meta Quest"
    ]
  },
  {
    id: 4,
    number: "04",
    title: "Sicurezza Cantieri",
    description: "Coordinamento della sicurezza in fase di progettazione ed esecuzione (CSP/CSE) secondo D.Lgs. 81/08.",
    icon: "ShieldCheck",
    details: [
      "Piani di Sicurezza e Coordinamento (PSC)",
      "Piani Operativi di Sicurezza (POS)",
      "Direzione lavori",
      "Verifiche di conformità normativa"
    ]
  },
  {
    id: 5,
    number: "05",
    title: "Contabilità e Stati Avanzamento Lavori",
    description: "Gestione contabile di cantiere, computi metrici estimativi e stati di avanzamento lavori (SAL).",
    icon: "FileText",
    details: [
      "Computi metrici estimativi",
      "Stati di Avanzamento Lavori (SAL)",
      "Quadri economici",
      "Contabilità finale"
    ]
  },
  {
    id: 6,
    number: "06",
    title: "Pratiche Catastali e Urbanistiche",
    description: "Variazioni catastali, studi di fattibilità e pratiche amministrative per edifici residenziali e commerciali.",
    icon: "Home",
    details: [
      "Variazioni catastali DOCFA",
      "Frazionamenti e accatastamenti",
      "Studi di fattibilità tecnico-economica",
      "Pratiche edilizie comunali"
    ]
  },
  {
    id: 7,
    number: "07",
    title: "Progettazione Interni e Virtual Reality",
    description: "Progettazione di interni con modellazione BIM 3D e visualizzazione immersiva tramite visore VR Meta Quest per un'esperienza realistica del progetto.",
    icon: "Glasses",
    details: [
      "Progettazione interni residenziali e commerciali",
      "Rendering fotorealistici",
      "Tour virtuali immersivi con Meta Quest"
    ]
  }
];

export const projects = [
  // Progetti F4 Ingegneria (09/2023 - 05/2024)
  {
    id: 1,
    title: "Parco Nazionale dello Stelvio",
    category: "Aerofotogrammetria",
    location: "Stelvio",
    description: "Rilievo aerofotogrammetrico e LIDAR di area protetta con tecnologia drone avanzata.",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f",
    year: "2024",
    area: "400 ha"
  },
  {
    id: 2,
    title: "Parco Nazionale Arcipelago Toscano",
    category: "Aerofotogrammetria",
    location: "Toscana",
    description: "Mappatura completa del territorio insulare con rilievi aerofotogrammetrici georeferenziati.",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f",
    year: "2024"
  },
  {
    id: 3,
    title: "Parco Nazionale dell'Asinara",
    category: "Aerofotogrammetria",
    location: "Sardegna",
    description: "Documentazione territoriale con rilievi multispettrali per area naturale protetta.",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f",
    year: "2024"
  },
  {
    id: 4,
    title: "Ispezione Linee Elettriche Spagna",
    category: "Ispezioni Aeree",
    location: "Spagna",
    description: "Ispezione termografica di 380 km di linee ad alta tensione con tecnologia UAV avanzata.",
    image: "https://images.unsplash.com/photo-1482050340796-deca383195b0",
    year: "2024",
    distance: "380 km"
  },
  {
    id: 5,
    title: "Rilievo Stradale",
    category: "Infrastrutture",
    location: "Italia",
    description: "Rilievo topografico di strade per progettazione e manutenzione infrastrutturale.",
    image: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea",
    year: "2024"
  },
  {
    id: 6,
    title: "Rilievo Galleria",
    category: "Infrastrutture",
    location: "Italia",
    description: "Documentazione geometrica di galleria esterna mediante tecnologia drone specializzata.",
    image: "https://images.unsplash.com/photo-1601074231509-dce351c05199",
    year: "2024"
  },
  {
    id: 7,
    title: "Edifici in Zone Aeronautiche",
    category: "Rilievi Topografici",
    location: "Zone militari",
    description: "Rilievi topografici di precisione per edifici situati in aree aeronautiche militari.",
    image: "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg",
    year: "2024"
  },
  {
    id: 8,
    title: "Aree Boschive",
    category: "Aerofotogrammetria",
    location: "Italia",
    description: "Mappatura e documentazione di aree boschive con rilievi aerofotogrammetrici.",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f",
    year: "2024"
  },
  {
    id: 9,
    title: "Aree Rurali",
    category: "Aerofotogrammetria",
    location: "Italia",
    description: "Rilievo aerofotogrammetrico di aree agricole e rurali per pianificazione territoriale.",
    image: "https://images.pexels.com/photos/24245275/pexels-photo-24245275.jpeg",
    year: "2023"
  },
  {
    id: 10,
    title: "Fabbricati Rurali",
    category: "Rilievi Topografici",
    location: "Campagna italiana",
    description: "Documentazione geometrica di edifici rurali con rilievi topografici e aerofotogrammetrici.",
    image: "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg",
    year: "2023"
  },
  {
    id: 11,
    title: "Grande Area 179 Ettari",
    category: "Aerofotogrammetria",
    location: "Italia",
    description: "Rilievo aerofotogrammetrico e topografico di vasta estensione per progetto territoriale.",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f",
    year: "2024",
    area: "179 ha"
  },
  
  // Progetti KRATOS (12/2022 - 08/2023)
  {
    id: 12,
    title: "S.S. 80 del Gran Sasso d'Italia",
    category: "Infrastrutture",
    location: "Abruzzo",
    description: "Rilievo topografico e gestione cantiere per ammodernamento strada statale.",
    image: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea",
    year: "2023"
  },
  {
    id: 13,
    title: "Adeguamento Ponte Via Falcinello",
    category: "Infrastrutture",
    location: "Peccioli",
    description: "Rilievo topografico e gestione cantiere per adeguamento ponte con passerella provvisoria.",
    image: "https://images.unsplash.com/photo-1601074231509-dce351c05199",
    year: "2023"
  },
  {
    id: 14,
    title: "Centro Storico Peccioli",
    category: "Aerofotogrammetria",
    location: "Peccioli",
    description: "Rilievo aerofotogrammetrico per progetto di accessibilità centro storico.",
    image: "https://images.unsplash.com/photo-1682663810771-89d21838530f",
    year: "2023"
  },
  
  // Progetti GEOMETRACOVING (02/2019 - 11/2022)
  {
    id: 15,
    title: "Rilievo Condominiale BIM",
    category: "Modellazione BIM",
    location: "Potenza",
    description: "Rilievo con drone e restituzione completa in BIM di condominio.",
    image: "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg",
    year: "2021"
  },
  
  // Progetti PRIVATI (2024 - Presente)
  {
    id: 16,
    title: "Studio Fattibilità Autolavaggio",
    category: "Progettazione",
    location: "Potenza",
    description: "Studio di fattibilità tecnico-economica per realizzazione autolavaggio self-service.",
    image: "https://images.unsplash.com/photo-1618385455730-2571c38966b7",
    year: "2025"
  },
  {
    id: 17,
    title: "Ristrutturazione Interna",
    category: "Pratiche Catastali",
    location: "Potenza",
    description: "Progettazione distribuzione interna con aggiornamenti catastali e pratiche comunali.",
    image: "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg",
    year: "2025"
  },
  {
    id: 18,
    title: "Riconfinamento Terreno",
    category: "Pratiche Catastali",
    location: "Potenza",
    description: "Riconfinamento catastale di terreno con verifica delle quote in fase di scavo.",
    image: "https://images.pexels.com/photos/24245275/pexels-photo-24245275.jpeg",
    year: "2025"
  },
  {
    id: 19,
    title: "Rilievo e Riconfinamento",
    category: "Rilievi Topografici",
    location: "Tito Scalo",
    description: "Rilievo aerofotogrammetrico, topografico e riconfinamento catastale di terreno.",
    image: "https://images.pexels.com/photos/24245275/pexels-photo-24245275.jpeg",
    year: "2025"
  },
  {
    id: 20,
    title: "Variazione Catastale Soffitta",
    category: "Pratiche Catastali",
    location: "Potenza",
    description: "Variazione catastale per diversa distribuzione interna di soffitta residenziale.",
    image: "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg",
    year: "2024"
  },
  {
    id: 21,
    title: "Variazione Catastale Appartamento",
    category: "Pratiche Catastali",
    location: "Maratea",
    description: "Pratiche catastali per ristrutturazione e diversa distribuzione interna.",
    image: "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg",
    year: "2024"
  },
  {
    id: 22,
    title: "Rilievo Topografico Terreno",
    category: "Rilievi Topografici",
    location: "Melfi",
    description: "Rilievo topografico di precisione per progettazione e pianificazione.",
    image: "https://images.pexels.com/photos/24245275/pexels-photo-24245275.jpeg",
    year: "2024"
  },
  {
    id: 23,
    title: "Rifacimento Tetto Condominio",
    category: "Coordinamento Sicurezza",
    location: "Potenza",
    description: "Direzione lavori e coordinamento sicurezza per ripristino copertura condominiale.",
    image: "https://images.unsplash.com/photo-1682663810771-89d21838530f",
    year: "2024"
  },
  {
    id: 24,
    title: "Riconfinamento Terreno Agricolo",
    category: "Pratiche Catastali",
    location: "Tito Scalo",
    description: "Riconfinamento catastale di terreno agricolo con documentazione completa.",
    image: "https://images.pexels.com/photos/24245275/pexels-photo-24245275.jpeg",
    year: "2024"
  },
  {
    id: 25,
    title: "Riconfinamento Catastale",
    category: "Pratiche Catastali",
    location: "Tito",
    description: "Operazioni di riconfinamento con rilievi topografici e documentazione catastale.",
    image: "https://images.pexels.com/photos/24245275/pexels-photo-24245275.jpeg",
    year: "2024"
  },
  {
    id: 26,
    title: "Rilievo Proprietà",
    category: "Rilievi Topografici",
    location: "Potenza",
    description: "Rilievo topografico e aerofotogrammetrico di proprietà residenziale.",
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f",
    year: "2024"
  },
  {
    id: 27,
    title: "Ispezione Copertura con Perizia",
    category: "Ispezioni Aeree",
    location: "Potenza",
    description: "Ispezione aerea con drone per verifica stato copertura e perizia tecnica asseverata.",
    image: "https://images.unsplash.com/photo-1482050340796-deca383195b0",
    year: "2024"
  },
  {
    id: 28,
    title: "Studio Fattibilità Capannone",
    category: "Progettazione",
    location: "Tito Scalo",
    description: "Studio di fattibilità preliminare per realizzazione capannone industriale.",
    image: "https://images.unsplash.com/photo-1618385455730-2571c38966b7",
    year: "2024"
  },
  {
    id: 29,
    title: "Rifacimento Copertura",
    category: "Coordinamento Sicurezza",
    location: "Pignola",
    description: "Direzione lavori e coordinamento sicurezza per rifacimento copertura.",
    image: "https://images.unsplash.com/photo-1682663810771-89d21838530f",
    year: "2025"
  },
  {
    id: 30,
    title: "Rifacimento Piazzale",
    category: "Coordinamento Sicurezza",
    location: "Potenza",
    description: "Riconfinamento, direzione lavori e coordinamento sicurezza per rifacimento piazzale.",
    image: "https://images.unsplash.com/photo-1682663810771-89d21838530f",
    year: "2025"
  },
  {
    id: 31,
    title: "Coordinamento Sicurezza Immobile",
    category: "Coordinamento Sicurezza",
    location: "Potenza - Tiera",
    description: "Coordinamento sicurezza in fase di progettazione ed esecuzione lavori.",
    image: "https://images.unsplash.com/photo-1601074231509-dce351c05199",
    year: "2024"
  },
  {
    id: 32,
    title: "Progettazione Interni VR",
    category: "Virtual Reality",
    location: "Potenza",
    description: "Progettazione interna in BIM con visualizzazione immersiva in Virtual Reality.",
    image: "https://images.unsplash.com/photo-1618385455730-2571c38966b7",
    year: "2024",
    sqm: "120 mq"
  }
];

export const technologies = [
  {
    id: 1,
    category: "Droni Professionali",
    items: [
      "DJI Mavic 3 Enterprise",
      "Droni ad alta precisione",
      "Rilievi aerofotogrammetrici avanzati",
      "Tecnologia georeferenziata di ultima generazione"
    ],
    icon: "Plane"
  },
  {
    id: 2,
    category: "Strumentazione Topografica",
    items: [
      "Stazione Totale professionale",
      "Precisione centimetrica",
      "Software topografici avanzati",
      "Livellazioni di precisione"
    ],
    icon: "Compass"
  },
  {
    id: 3,
    category: "Software BIM e GIS",
    items: [
      "Revit, Archicad, Edificius",
      "Agisoft Metashape Pro",
      "Autocad Civil 3D 2025",
      "QGIS, Thopos 2024"
    ],
    icon: "Monitor"
  },
  {
    id: 4,
    category: "Virtual Reality",
    items: [
      "Meta Quest VR",
      "Visualizzazione progetti immersiva",
      "Presentazioni clienti interattive",
      "Tour virtuali cantieri"
    ],
    icon: "Glasses"
  }
];

export const certifications = [
  {
    id: 1,
    title: "Abilitazione Professionale Geometra",
    number: "P.IVA 02151450760 - Timbro 3306"
  },
  {
    id: 2,
    title: "Coordinamento Sicurezza CSE/CSP",
    number: "Attestato n°12C24N01 - D.Lgs. 81/08"
  }
];

export const aboutContent = {
  intro: "Geometra abilitato con esperienza pluriennale nel settore delle costruzioni, topografia e sicurezza cantieri. Specializzato in tecnologie innovative per rilievi di precisione.",
  experience: [
    {
      period: "2026 - Presente",
      company: "GEOCART S.P.A.",
      role: "Geometra Topografo",
      description: "Rilievi di Parchi Nazionali con tecnologia LIDAR e ispezioni di linee elettriche ad alta tensione."
    },
    {
      period: "2024 - Presente",
      company: "Libero Professionista",
      role: "Geometra - Topografo",
      description: "Studio tecnico privato: rilievi topografici, aerofotogrammetrici, direzione lavori, pratiche catastali e coordinamento sicurezza."
    },
    {
      period: "2023 - 2024",
      company: "F4 INGEGNERIA S.R.L.",
      role: "Topografo Specializzato",
      description: "Rilievi aerofotogrammetrici georeferenziati per comuni e parchi nazionali, con estensioni fino a 179 ettari."
    },
    {
      period: "2022 - 2023",
      company: "KRATOS S.R.L.",
      role: "Geometra di Cantiere",
      description: "Gestione cantieri infrastrutturali: S.S. 80 Gran Sasso, adeguamento ponti, contabilità SAL."
    },
    {
      period: "2019 - 2022",
      company: "GEOMETRACOVING S.R.L.",
      role: "Geometra Progettista",
      description: "Progettazione, computi metrici, piani di sicurezza, rilievi energetici e restituzioni BIM."
    }
  ],
  values: [
    {
      title: "Precisione",
      description: "Accuratezza garantita da strumentazione GPS RTK e metodologie certificate."
    },
    {
      title: "Innovazione",
      description: "Tecnologie all'avanguardia: droni professionali, LIDAR, BIM e Virtual Reality."
    },
    {
      title: "Affidabilità",
      description: "Oltre 5 anni di esperienza su progetti di infrastrutture, edilizia e parchi nazionali."
    }
  ]
};
